export const environment = {
  production: true,
  name: 'production',

  backend: {
    url: 'https://api.backoffice.fsbr.qualitylabs.com.br',
  },
  recaptcha: {
    siteKey: null,
  }
};
